module.exports = __webpack_public_path__ + "img/solution--fall-prevention.4ea7ec39.jpg";